/* FF Lightbox: öffnet Bilder und Videos aus der Mini-Leiste (Produktseite) und der Community-Sektion
   im Vollbild. Jedes klickbare Element trägt:
     data-ff-lb-src     → Bild- oder Video-URL
     data-ff-lb-type    → "image" | "video"
     data-ff-lb-group   → Elemente derselben Gruppe lassen sich mit Pfeilen/Wischen durchblättern
     data-ff-lb-poster  → (optional) Vorschaubild fürs Video
     data-ff-lb-alt     → (optional) Alt-Text fürs Bild
   Das Overlay wird erst beim ersten Öffnen gebaut; mehrfaches Einbinden der Datei ist unschädlich. */
(function () {
  if (window.__ffLightbox) return;
  window.__ffLightbox = true;

  var root, frame, media, prevBtn, nextBtn, countEl, closeBtn;
  var items = [];
  var idx = 0;
  var lastFocus = null;
  var touchX = null;
  var loadTimer = null;
  /* Wer gerade eine Leiste wischt, soll beim Antippen nicht versehentlich die Vollbild-Ansicht öffnen. */
  var lastTrackScroll = 0;
  document.addEventListener('scroll', function (e) {
    if (e.target !== document) lastTrackScroll = Date.now();
  }, { capture: true, passive: true });

  function build() {
    root = document.createElement('div');
    root.className = 'ff-lb';
    root.hidden = true;
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Medienansicht');
    root.innerHTML =
      '<div class="ff-lb__backdrop" data-ff-lb-close></div>' +
      '<div class="ff-lb__frame" data-ff-lb-frame>' +
        '<div class="ff-lb__skeleton" aria-hidden="true"></div>' +
        '<div class="ff-lb__media" data-ff-lb-media></div>' +
        '<button type="button" class="ff-lb__btn ff-lb__close" data-ff-lb-close aria-label="Schließen">&times;</button>' +
        '<button type="button" class="ff-lb__btn ff-lb__nav ff-lb__prev" data-ff-lb-prev aria-label="Zurück">&#8249;</button>' +
        '<button type="button" class="ff-lb__btn ff-lb__nav ff-lb__next" data-ff-lb-next aria-label="Weiter">&#8250;</button>' +
        '<div class="ff-lb__count" data-ff-lb-count aria-live="polite"></div>' +
      '</div>';
    document.body.appendChild(root);
    frame = root.querySelector('[data-ff-lb-frame]');
    media = root.querySelector('[data-ff-lb-media]');
    prevBtn = root.querySelector('[data-ff-lb-prev]');
    nextBtn = root.querySelector('[data-ff-lb-next]');
    countEl = root.querySelector('[data-ff-lb-count]');
    closeBtn = root.querySelector('.ff-lb__close');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ff-lb-prev]')) go(-1);
      else if (e.target.closest('[data-ff-lb-next]')) go(1);
      else if (e.target.closest('[data-ff-lb-close]')) close();
    });
    root.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40 && items.length > 1) go(dx < 0 ? 1 : -1);
    });
  }

  /* Skeleton zeigen, bis Bild/Video Daten hat; der Rahmen hat feste Maße, damit nichts springt. */
  function loading(on) {
    clearTimeout(loadTimer);
    frame.classList.toggle('is-loading', on);
    if (on) loadTimer = setTimeout(function () { frame.classList.remove('is-loading'); }, 8000);
  }

  function render() {
    var el = items[idx];
    media.innerHTML = '';
    var src = el.getAttribute('data-ff-lb-src');
    var isVideo = el.getAttribute('data-ff-lb-type') === 'video';
    frame.classList.toggle('ff-lb__frame--video', isVideo);
    loading(true);
    if (isVideo) {
      var v = document.createElement('video');
      v.addEventListener('loadeddata', function () { loading(false); }, { once: true });
      v.addEventListener('error', function () { loading(false); }, { once: true });
      v.src = src;
      v.controls = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      var poster = el.getAttribute('data-ff-lb-poster');
      if (poster) v.poster = poster;
      media.appendChild(v);
      /* Der Klick des Nutzers erlaubt Ton; blockiert der Browser trotzdem, stumm weiterspielen. */
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
    } else {
      var img = document.createElement('img');
      img.addEventListener('load', function () { loading(false); }, { once: true });
      img.addEventListener('error', function () { loading(false); }, { once: true });
      img.src = src;
      img.alt = el.getAttribute('data-ff-lb-alt') || '';
      media.appendChild(img);
    }
    var many = items.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
    countEl.textContent = many ? (idx + 1) + ' / ' + items.length : '';
  }

  function go(step) {
    idx = (idx + step + items.length) % items.length;
    render();
  }

  function open(el) {
    if (!root) build();
    var group = el.getAttribute('data-ff-lb-group');
    items = group
      ? Array.prototype.slice.call(document.querySelectorAll('[data-ff-lb-group="' + (window.CSS && CSS.escape ? CSS.escape(group) : group) + '"]'))
      : [el];
    idx = Math.max(0, items.indexOf(el));
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('ff-lb-open');
    render();
    closeBtn.focus();
  }

  function close() {
    if (!root || root.hidden) return;
    media.innerHTML = ''; /* stoppt ein laufendes Video */
    loading(false);
    root.hidden = true;
    document.documentElement.classList.remove('ff-lb-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-ff-lb-src]');
    if (!el || (root && root.contains(el))) return;
    e.preventDefault();
    if (Date.now() - lastTrackScroll < 250) return;
    open(el);
  });

  document.addEventListener('keydown', function (e) {
    if (!root || root.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft' && items.length > 1) go(-1);
    else if (e.key === 'ArrowRight' && items.length > 1) go(1);
  });
})();
